import image from '@/assets/images/manufacturers/grundfos.png';
import { option } from '@/util/container';
import { MANUFACTURERS } from '..';

export default option(MANUFACTURERS, async () => ({
  name: 'GRUNDFOS',
  label: 'Grundfos',
  image,
}));
